// components/GlowBackground.tsx
import React, { ReactNode } from 'react';

interface GlowBackgroundProps {
  children?: ReactNode;
  className?: string;
}

const GlowBackground: React.FC<GlowBackgroundProps> = ({
  children,
  className = '',
}) => {
  return (
    // Added overflow-hidden to prevent this div from ever scrolling.
    // className (e.g., flex-1, p-8) is applied here.
    <div className={`glow-background relative bg-beige-25 overflow-hidden ${className}`}>
      {/* Added h-full to make this div fill its parent's height (respecting parent's padding).
          This div is now the one whose height children passed to GlowBackground will see. */}
      <div className="relative z-10 h-full">
        {children}
      </div>
    </div>
  );
};

export default GlowBackground;